import api from './api';

export interface MaintenanceSchedule {
  id: number;
  equipment_id: number;
  equipmentName?: string;
  scheduled_date: string;
  type: string;
  technician_id: number;
  technicianName?: string;
  status: string;
  notes?: string;
}

export interface NewSchedule {
  equipment_id: number;
  scheduled_date: string;
  type: string;
  status?: string; // Ajout du status comme optionnel
  technician_id: number;
  notes?: string;
}

const maintenanceSchedulesService = {
  async getAll() {
    return api.get('/maintenance-schedules');
  },
  async getById(id: number) {
    return api.get(`/maintenance-schedules/${id}`);
  },
  async create(data: NewSchedule) {
    return api.post('/maintenance-schedules', data);
  },
  async update(id: number, data: Partial<NewSchedule>) {
    return api.put(`/maintenance-schedules/${id}`, data);
  },
  async remove(id: number) {
    return api.delete(`/maintenance-schedules/${id}`);
  }
};

export default maintenanceSchedulesService;
